import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../components/vantForm.vue';
import ResultPage from '../components/ResultPage.vue';
import Login from '../components/Login.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: Login },
  { path: '/', component: Login },
  {  path: '/result',
    name: 'ResultPage',
    component: ResultPage,
    props: true,} ,// 允许通过路由传递参数 }
    {  path: '/home',
    name: 'Home',
    component: Home,
    }
];

const router = new VueRouter({
  mode: 'history', // 使用 HTML5 history 模式
  routes
});

export default router;

// 全局前置守卫，判断登录状态
// 全局前置守卫，判断登录状态
router.beforeEach((to, from, next) => {
  // 判断是否已登录，这里以 localStorage 的 phone 为例
  const isLogin = !!localStorage.getItem('phone');
  if (to.path !== '/login' && !isLogin) {
    next('/login'); // 如果未登录且不是登录页，则跳转到登录页
  } else {
    next(); // 否则继续导航
  }
});